import { SidebarMenuItem as SidebarMenuItemGeneric } from "@package/ui-components";
import { type SidebarEntry } from "@package/ui-config";
import { useLocation, useNavigate } from "react-router";

export function SidebarMenuItem({ entry }: { entry: SidebarEntry }) {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  const path = `/${entry.path}`;

  return (
    <SidebarMenuItemGeneric
      icon={entry.icon}
      text={entry.text}
      active={pathname?.startsWith(path)}
      path={entry.path}
      onClick={() => navigate(path + search)}
    />
  );
}
